import { render } from "./templateGameOver.vue?vue&type=template&id=22a64aa3"
import script from "./templateGameOver.vue?vue&type=script&lang=js"
export * from "./templateGameOver.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__